<template>
    <div class="inner-wrap">
        <div class="left" :style="{'height': height}">
            <div class="tab-list">
                <div :class="{ active: current_tab1 === 'default' }" class="cursor tab-item" @click="change_tab1('default')">Platform Fabric</div>
                <div class="shu"></div>
                <div :class="{ active: current_tab1 === 'self' }"  class="cursor tab-item" @click="change_tab1('self')">Self-provided Fabric</div>

            </div>
            <p class="tip3">
                <span class="red">*</span>1. Fabric A is the main fabric
            </p>
            <div class="mlist" v-show="current_tab1==='default'">
                <div class="item" v-for="(v, k) in form_data.material" :key="`m` + k">
                    <div class="img-wrap">
                        <img :src="v.image | default_img" alt="" class="img" v-viewer>
                        <select :value="form_data.material[k].alias" @change="input2($event, 'material', k, 'alias')" style="border: none; outline: none">
                            <option value="">Please Select</option>
                            <option value="Fabric A">Fabric A</option>
                            <option value="Fabric B">Fabric B</option>
                            <option value="Fabric C">Fabric C</option>
                            <option value="Fabric D">Fabric D</option>
                            <option value="Fabric E">Fabric E</option>
                            <option value="Fabric F">Fabric F</option>
                            <option value="Fabric G">Fabric G</option>
                            <option value="Fabric H">Fabric H</option>
                            <option value="Fabric I">Fabric I</option>
                            <option value="Fabric J">Fabric J</option>
                        </select>
                    </div>

                    <div class="r1">
                        <div class="name">{{ v.fabric_name_en }}</div>
                        <div class="tag-list">
                            <div class="tag-item" style="width: 100%">
                                <span class="key" > No.:</span>
                                <span class="value">{{v.fabric_key}}</span>
                            </div>
                            <div class="tag-item">
                                <span class="key">Width:</span>
                                <span class="value">{{v.width_wide}} CM</span>
                            </div>
                            <div class="tag-item">
                                <span class="key">Weight:</span>
                                <span class="value">{{v.weight}} </span>
                            </div>
                            <div class="tag-item" style="width: 100%">
                                <span class="key">Composition:</span>
                                <span class="value">{{v.component_en}}</span>
                            </div>
                            <div class="tag-item">
                                <span class="key">Color:</span>
                                <select class="value" :value="form_data.material[k].color_key" @input="change3($event, 'material', k, 'color_key')">
                                    <option v-for="(vv) in form_data.material[k].color_list" :value="vv.color_key">{{vv.color_name_en}}</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label >Note</label>
                        <input :value="form_data.material[k].desc" @input="input2($event, 'material', k, 'desc')" placeholder="Note" type="text" class="desc" />
                    </div>
                    <img src="@/assets/images/design/icon-del.png" class="icon-del cursor" @click.prevent="del_material(k)" />
                </div>
            </div>


            <div class="mlist2" v-show="current_tab1==='self'">
                <div class="item" v-for="(v, k) in form_data.material_self" :key="`ms` + k">
                    <div class="img-wrap ">
                        <Upload
                                :action="upload_url"
                                :data="{ dir: 'template' }"
                                :before-upload="(file)=>onBeforeUpload(file, k)"
                                :show-upload-list="false"
                                :format="['jpg','jpeg','png','gif']"
                                accept=".jpg,.jpeg,.png,.gif"
                        >
                            <template v-if="v.image">
                                <div class="img-box">
                                    <img @click.stop :src="v.image" class="img" v-viewer />
                                    <div class="replace-btn">
                                        <img src="@/assets/images/icon-file-upload.png" alt="" class="ico">
                                        <div class="text">Re-upload</div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="img-default cursor">
                                    <img class="img2" src="@/assets/images/design/icon-add.png"/>
                                    <p>Upload</p>
                                </div>
                            </template>
                        </Upload>
                        <select :value="form_data.material_self[k].alias" @change="input2($event, 'material_self', k, 'alias')" style="border: none; outline: none">
                            <option value="">Please select</option>
                            <option value="Fabric A">Fabric A</option>
                            <option value="Fabric B">Fabric B</option>
                            <option value="Fabric C">Fabric C</option>
                            <option value="Fabric D">Fabric D</option>
                            <option value="Fabric E">Fabric E</option>
                            <option value="Fabric F">Fabric F</option>
                            <option value="Fabric G">Fabric G</option>
                            <option value="Fabric H">Fabric H</option>
                            <option value="Fabric I">Fabric I</option>
                            <option value="Fabric J">Fabric J</option>
                        </select>
                    </div>

                    <div class="r1">
                        <div class="tag-list">
                            <div class="tag-item" >
                                <span class="key" >Name:</span>
                                <input class="value" :value="form_data.material_self[k].fabric_name_cn" @input="input2($event, 'material_self', k, 'fabric_name_cn')" placeholder="Fabric Name" type="text"/>
                            </div>
                            <div class="tag-item" >
                                <span class="key" >No.:</span>
                                <input class="value" :value="form_data.material_self[k].fabric_key" @input="input2($event, 'material_self', k, 'fabric_key')" placeholder="Fabric No." type="text"/>
                            </div>
                            <div class="tag-item">
                                <span class="key">Width:</span>
                                <input class="value" :value="form_data.material_self[k].width_wide" @input="input2($event, 'material_self', k, 'width_wide')" placeholder="Width, Unit:CM" type="text"/>
                            </div>
                            <div class="tag-item" >
                                <span class="key">Composition:</span>
                                <input class="value" :value="form_data.material_self[k].component" @input="input2($event, 'material_self', k, 'component')" placeholder="Composition" type="text"/>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label >Note</label>
                        <input :value="form_data.material_self[k].desc" @input="input2($event, 'material_self', k, 'desc')" placeholder="Note" class="desc" type="text"/>
                    </div>
                    <img src="@/assets/images/design/icon-del.png" class="icon-del cursor" @click.prevent="del_material_self(k)" />
                </div>

                <div class="btn-continue cursor" @click="add_material_self">
                    + Add Fabric
                </div>
            </div>

        </div>

        <!--  :style="{width: width}" -->
        <div class="right">
            <template v-if="is_lesson_show">
                <Lesson ></Lesson>
            </template>
            <template v-else>
                <!-- :style="{ 'height': height,overflow: 'auto'}" -->
                <div class="material-wrap">
                    <div class="top">
                        <!-- <h2>面料选择</h2> -->
                        <div class=title-box>
                            <span @click="onFabricTypeClick(1)" :class="[form_data_fabric.type === 1 ? 'active' :'']">Fabric Selection</span>
                            <span>|</span>
                            <span @click="onFabricTypeClick(2)" :class="[form_data_fabric.type === 2 ? 'active' :'']">Lining Selection</span>
                        </div>
                        <div class="input-wrap">
                            <input v-model="form_data_fabric.keyword" placeholder="Enter keywords to search for fabrics" type="text" @keyup.enter="search_fabric"/>
                            <img alt="" class="icon-search" src="@/assets/images/icon-search.png" @click="search_fabric"/>
                        </div>
                    </div>
                    <div class="content">
                        <div class="left-content category-list">
                            <div v-for="(v, k) in fabric_category_list" :key="`dc` + k" :class="{active: current_fabric_category_id === v.fabric_category_id}" class="category-item cursor" @click="choose_fabric_category(v)">
                                {{ v.category_name_en }}
                            </div>
                        </div>
                        <div class="right-content">
                            <div v-for="(v, k) in fabric_label_list" :key="`lf1` + k" class="label-list">
                                <div class="label-item">
                                    <p>{{ v.label_name_en }}：</p>
                                </div>
                                <div
                                        v-for="(vv, kk) in v.content_en"
                                        :key="`lf2` + kk"
                                        :class="{ active: fabric_label_ids.includes(vv.id) }"
                                        class="label-item"
                                        @click="choose_label(vv)"
                                >
                                    <p>{{ vv.name }}</p>
                                </div>
                            </div>
                            <div v-show="sub_fabric_category_list.length > 0" class="sub-list">
                                <div
                                        v-for="(v, k) in sub_fabric_category_list"
                                        :key="`fpsa` + k"
                                        :class="{active:current_sub_fabric_category_id === v.fabric_category_id,}"
                                        class="sub-item"
                                        @click="choose_sub_fabric_category(v)"
                                >
                                    <p>{{ v.category_name_en }}</p>
                                </div>
                            </div>
                            <template v-if="fabric_list.length > 0">
                                <div class="fabric-list">
                                    <div
                                            v-for="(v, k) in fabric_list"
                                            :key="`df` + k"
                                            :class="{ active: selected_ids.includes(v.id)}"
                                            class="fabric-item"
                                            @click="toggle_material(v)"
                                    >
                                        <img :src="v.image | default_img" alt="" />
                                        <p>{{ v.fabric_name_en }}</p>
                                        <img v-show="selected_ids.includes(v.id)" alt="" class="icon-check" src="@/assets/images/icon-check.png"/>
                                        <div class="mask">
                                            <div class="btn">
                                                <span class="fa-detail" @click.stop="open_fabric_detail(v)">View</span>
                                                <span class="fa-choose" @click.stop="toggle_material(v)"> {{selected_ids.includes(v.id) ? 'Cancel':'Select'}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Page :current="form_data_fabric.page" v-if="total>0" :page-size="form_data_fabric.size"  :total="total" @on-change="changePage" show-total style="margin-top: 20px;"  ></Page>
                            </template>
                            <template v-else>
                                <img class="no-data" :src="require(`@/assets/images/no-data.png`)" alt="">
                            </template>

                        </div>
                    </div>
                    <div v-show="is_color_show" class="color-mask">
                        <div class="color-wrap">
                            <h2 class="title">Color Selection</h2>
                            <div class="color-list">
                                <div v-for="(v, k) in current_temp_fabric.color_list"
                                     :class="{active: current_temp_fabric.color_id === v.color_id,}"
                                     class="color-item"
                                     @click="choose_color(v)" :key="k"
                                >
                                    <img v-viewer @click.stop :src="v.color_value|default_img" alt="" />
                                    <span class="name">{{ v.color_name_en }}</span>
                                </div>
                            </div>
                            <div class="btn-group">
                                <div class="btn btn-cancel" @click="close_color_modal">Cancel</div>
                                <div class="btn btn-confirm" @click="confirm_color">Confirm</div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>

        <popup :show.sync="is_popup_show_detail" height="680px" width="980px" @on-close="close_fabric_detail">
            <div class="fabric-content-wrap" style="height:100% !important;">
                <div class="info-wrap">
                    <div class="left-popup">
                        <div v-if="current_temp_fabric.image_list.length > 0 || current_temp_fabric.video" class="slider">
                            <swiper ref="swiper" :options="swiperOption">
                                <swiper-slide v-if="current_temp_fabric.video">
                                    <video v-if="current_temp_fabric.video" :src="current_temp_fabric.video" muted autoplay controls id="video-material" >您的浏览器不支持视频播放。</video>
                                </swiper-slide>
                                <swiper-slide
                                        v-for="(item, index) in current_temp_fabric.image_list"
                                        :key="`sl` + index"
                                >
                                    <img v-viewer :src="item.url" class="img" />
                                </swiper-slide>
                                <!--                                    <div class="swiper-pagination" slot="pagination"></div>-->
                                <div slot="button-prev" class="swiper-button-prev"></div>
                                <div slot="button-next" class="swiper-button-next"></div>
                            </swiper>
                        </div>
                    </div>
                    <div class="right">
                        <p class="name">{{ current_temp_fabric.fabric_name_en }}</p>
                        <p class="no">Fabric No.:{{ current_temp_fabric.fabric_key }}</p>
                        <p class="price"> Price:${{ current_temp_fabric.fabric_price }}{{ current_temp_fabric.unit_en ? '/'+current_temp_fabric.unit_en:'' }}</p>
                        <div class="title" style="border-top: 1px solid #e0e0e0;margin-bottom:20px;">
                            <!-- 面料参数 -->
                        </div>
                        <div class="list">
                            <div class="item"><span class="key">Unit:</span><span class="value">{{ current_temp_fabric.unit_en || '' }}</span></div>
                            <div class="item"><span class="key">Width:</span><span class="value">{{ current_temp_fabric.width_wide }} CM</span></div>
                            <div class="item"><span class="key">Weight:</span><span class="value">{{ current_temp_fabric.weight }} <template v-if="current_temp_fabric.unit_weight==2">G/M<sup>2</sup></template><template v-if="current_temp_fabric.unit_weight==1">G/M</template></span></div>
                            <div class="item"><span class="key">Composition:</span><span class="value">{{ current_temp_fabric.component_en }}</span></div>
                            <div class="item"><span class="key">National Standard:</span><span class="value">{{ current_temp_fabric.standard }}</span></div>
                            <div class="item"><span class="key" style="">Sample Service Provided:</span><span class="value">{{ current_temp_fabric.is_support_send_sample ? 'Yes' :'No' }}</span></div>
                            <div class="color-title">Color Selection:</div>
                            <div class="color-box">
                                <div v-for="(item,index) in current_temp_fabric.color_list" :key="index" @click="choose_color(item)" :class="['color-item',{active:current_temp_fabric.color_id === item.color_id}]">
                                    <img v-viewer @click.stop :src="item.color_value|default_img" alt="" class="color-img" />{{ item.color_name_en }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="title-box">
                    <div class="title">Product Details</div>
                    <div class="line"></div>
                </div>
                <div class="richtext-wrap" v-html="current_temp_fabric.description"></div>
                <div class="btn-box">
                    <button class="cancel-btn" @click="close_fabric_detail">Cancel</button>
                    <button class="confirm-btn" @click="confirm_color_detail">Confirm Selection</button>
                </div>
            </div>
        </popup>

    </div>
</template>

<script>
    import {
    FabricCategoryList,
    FabricLabelList,
    FabricList,
} from "@/api/index.js";
import Popup from "@/components/Popup.vue";
import { uploadFileToOSS } from "@/utils/oss";
import axios from "axios";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapState } from 'vuex';
import Lesson from "./Lesson.vue";
    export default {
        name: "Material",
        data() {
            return {
                swiperOption: {
                    loop: false, // 循环播放, 可有无限滚动效果，初始加载即是滚动后的效果
                    autoplay: false,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                    },
                    on: {
                        slideChange: function () {
                            if(document.getElementById('video-material')) {
                                if(this.activeIndex === 0) {
                                    document.getElementById('video-material').play()
                                } else {
                                    document.getElementById('video-material').pause()
                                }
                            }
                        },
                    },
                    observer: true, //修改swiper自己或子元素时，自动初始化swiper
                    observeParents: true, //修改swiper的父元素时，自动初始化swiper
                },
                upload_url: process.uniEnv.BASE_API + "/util/upload-image",
                form_data_fabric: {
                    page: 1,
                    size: 20,
                    keyword: "",
                    fabric_category_id: 0,
                    type:1
                },
                total: -1,
                fabric_label_list: [],
                fabric_label_ids: [],
                sub_fabric_category_list: [],
                fabric_category_list: [],
                fabric_list: [],
                current_fabric_category_id: 0,
                current_sub_fabric_category_id: 0,
                current_temp_fabric: {
                    image_list: [],
                },
                is_popup_show_detail: false,
                is_color_show: false,
                current_tab1: "default",
                width: '600px',
            }
        },
        components: {
            Popup,
            swiper,
            swiperSlide,
            Lesson
        },
        watch: {
            "form_data.parent_product_category_id": {
                handler(newVal, oldVal) {
                    if (newVal > 0) {
                        this.getFabricCategoryList()
                    }
                },
                immediate: true, // 立即执行一次handler以初始化数据
                deep: true, // 深度监听（虽然在这个场景下可能不是必需的）
            },
        },
        computed: {
            ...mapState({
                form_data: (state) => state.design.form_data,
                height: (state) => state.design.height,
                is_lesson_show: (state) => state.design.is_lesson_show,
                product_category_list: (state) => state.design.product_category_list,
            }),
            selected_ids() {
                return this.form_data.material.map(v=>v.id)
            },
        },
        methods: {
            onFabricTypeClick(val){
                this.form_data_fabric.type = val;
                this.getFabricList();
            },
            onBeforeUpload(file,k){
                uploadFileToOSS(file, 'template').then(res => {
                    let object = this.form_data.material_self[k]
                    object.image = res;
                    this.$store.commit('design/arr_update_one', {key: 'material_self', index: k, value: object})
                })
                return false;
            },
            change_tab1(c) {
                this.current_tab1 = c;
            },
            choose_label(v) {
                if (this.fabric_label_ids.includes(v.id)) {
                    this.fabric_label_ids = this.fabric_label_ids.filter((item) => {
                        return item !== v.id;
                    });
                } else {
                    this.fabric_label_ids.push(v.id);
                    this.fabric_label_ids = [...new Set(this.fabric_label_ids)];
                }
                this.form_data_fabric.page = 1
                this.getFabricList();
            },
            del_material(k) {
                this.$DModal.confirm({
                    content: 'Do you want to cancel the selected data?',
                    okText:'Confirm',
                    cancelText:'Cancel',
                    onOK: async () => {
                        this.$store.commit('design/arr_remove_one', {key: 'material', index: k})
                    }
                })
            },
            toggle_material(v) {
                if(this.selected_ids.includes(v.id)) {
                    let idx = this.form_data.material.findIndex(obj => obj.id===v.id)
                    this.del_material(idx)
                } else {
                    this.open_color_modal(v)
                }
            },
            open_color_modal(fabric) {
                this.current_temp_fabric = Object.assign({}, fabric);
                if (this.current_temp_fabric.color_list.length > 1) {
                    this.is_color_show = true;
                } else {
                    this.choose_color(this.current_temp_fabric.color_list[0])
                    this.confirm_color()
                }
            },
            choose_color(v) {
                this.$set(this.current_temp_fabric, "color_name_en", v.color_name_en);
                this.$set(this.current_temp_fabric, "color_name_cn", v.color_name_cn);
                this.$set(this.current_temp_fabric, "color_value", v.color_value);
                this.$set(this.current_temp_fabric, "color_key", v.color_key);
                this.$set(this.current_temp_fabric, "color_id", v.color_id)
            },
            confirm_color() {
                if(this.form_data.material.length + this.form_data.material_self.length >= 10) {
                    this.$layer.msg(`You can add up to 10 fabrics`)
                    return
                }
                let object = {...this.current_temp_fabric, desc: "", alias: ""}
                this.$store.commit("design/arr_push_one", {key: 'material', value: object})
                this.is_color_show = false;
                this.reset_temp_fabric()
            },
            confirm_color_detail() {
                if(this.form_data.material.length + this.form_data.material_self.length >= 10) {
                    this.$layer.msg(`You can add up to 10 fabrics`)
                    return
                }
                let object = {...this.current_temp_fabric, desc: "", alias: ""}
                this.$store.commit("design/arr_push_one", {key: 'material', value: object})
                this.is_popup_show_detail = false;
                this.reset_temp_fabric()
            },
            close_color_modal() {
                this.is_color_show = false;
                this.reset_temp_fabric()
            },
            add_material_self() {
                if(this.form_data.material.length + this.form_data.material_self.length >= 10) {
                    this.$layer.msg(`You can add up to 10 fabrics`)
                    return
                }
                let object = {alias: "", image: "", fabric_key: "", fabric_name_cn: "", width_wide: "",component: "", desc: "",}
                this.$store.commit("design/arr_push_one", {key: 'material_self', value: object})
            },
            del_material_self(k) {
                this.$store.commit('design/arr_remove_one', {key: 'material_self', index: k})
            },
            open_fabric_detail(v) {
                this.current_temp_fabric = v;
                if(this.current_temp_fabric.color_list.length === 1){
                    this.choose_color(this.current_temp_fabric.color_list[0])
                }
                this.is_popup_show_detail = true;
            },
            close_fabric_detail() {
                this.reset_temp_fabric()
                this.is_popup_show_detail = false;
            },
            reset_temp_fabric() {
                this.current_temp_fabric = {image_list: []};
            },
            changePage(page) {
                this.form_data_fabric.page = page
                this.getFabricList()
            },
            search_fabric() {
                this.getFabricList();
            },
            choose_fabric_category(category) {
                this.current_fabric_category_id =
                    this.form_data_fabric.fabric_category_id = category.fabric_category_id;
                if (category.fabric_category_id === 0) {
                    this.sub_fabric_category_list = [];
                } else {
                    this.sub_fabric_category_list = category.children;
                }
                this.current_sub_fabric_category_id = 0;
                this.form_data_fabric.page = 1
                this.getFabricList();
            },
            choose_sub_fabric_category(category) {
                this.current_sub_fabric_category_id =
                    this.form_data_fabric.fabric_category_id = category.fabric_category_id;
                this.form_data_fabric.page = 1
                this.getFabricList();
            },
            async getFabricCategoryList() {
                return FabricCategoryList({product_category_id: this.form_data.parent_product_category_id}).then((response) => {
                    this.fabric_category_list = [
                        { category_name_en: "All", fabric_category_id: 0 },
                        ...response.data,
                    ];
                    return response;
                });
            },
            async getFabricLabelList() {
                return FabricLabelList().then((response) => {
                    this.fabric_label_list = [...response.data];
                    return response;
                });
            },
            async getFabricList() {
                return FabricList({
                    ...this.form_data_fabric,
                    label_id: this.fabric_label_ids,
                }).then((response) => {
                    this.fabric_list = response.data.list;
                    this.total = response.data.total;
                    return response;
                });
            },
            async input2($event, field, k, child_field) {
                const newValue = $event.target.value;
                const originalItem = JSON.parse(JSON.stringify(this.form_data[field][k]));
                let updatedItem;
                // 创建一个全新对象，防止引用污染
                if(child_field === 'alias'){
                    updatedItem = {...originalItem,alias:newValue};
                }else{
                    updatedItem = {
                        ...originalItem,
                        [child_field]: newValue
                    }
                }
                await this.$store.commit('design/arr_update_one', {key: field, index: k, value:updatedItem})
            },
            change3($event, field, k, child_field) {
                let object = this.form_data[field][k]
                let o = object.color_list.find(v=>v.color_key == $event.target.value)
                if(o) {
                    object[child_field] = $event.target.value
                    object[`color_name_cn`] = o.color_name_cn
                    object[`color_name_en`] = o.color_name_en
                    object[`color_value`] = o.color_value
                }
                this.$store.commit('design/arr_update_one', {key: field, index: k, value: object})
            },
        },
        mounted() {
            this.width = window.innerWidth - 220 - 490 - 30 + 'px'
            axios.all([
                this.getFabricCategoryList(),
                this.getFabricLabelList(),
            ]).then(
                axios.spread(() => {
                    this.getFabricList();
                })
            )
        }
    }
</script>

<style scoped lang="scss">
    .inner-wrap {
        display: flex;
        flex-wrap: nowrap;
        height:100%;
        .left {
            padding: 0 30px 100px 30px;
            // width: 490px;
            // width:100%;
            flex:0 0 490px;
            height:100%;
            background: white;
            overflow: auto;
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;
            .tab-list {
                margin-top: 20px;
                width: 100%;
                padding-bottom: 15px;
                display: flex;
                flex-wrap: nowrap;
                align-items: center;
                border-bottom: 1px solid #E6E6E6;
                line-height:20px;
                .tab-item {
                    // width: 110px;
                    color: #4D4D4D;
                    font-size: 16px;
                    text-align: center;
                    &.active {
                        font-weight: bold;
                        color: black;
                        font-size: 18px;
                    }
                }
                .shu {
                    width: 2px;
                    height: 20px;
                    margin: 0 10px;
                    background: #808080;
                }
            }
            h1 {
                width: 100%;
                height: 20px;
                line-height: 20px;
                font-size: 18px;
                color: #000000;
                border-left: 2px solid black;
                padding-left: 10px;
                margin: 15px 0;
            }

            .tip3 {
                margin: 20px 0 10px 0;
                font-weight: bolder;
                font-size: 14px;
                color: red;
            }

            .mlist {
                display: flex;
                flex-wrap: wrap;
                width:100%;
                .item {
                    position: relative;
                    // width: 420px;
                    width:100%;
                    max-width:420px;
                    margin-bottom: 10px;
                    padding: 10px;
                    border: 1px solid #BFBFBF;
                    border-radius: 5px;
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    .img-wrap {
                        position: relative;
                        width: 100px;
                        height: 100px;
                        .img {
                            width: 100%;
                            height: 100%;
                            object-fit: contain;
                        }
                        select {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 75px;
                            height: 25px;
                            background: rgba(0, 0, 0, 0.5);
                            border-radius: 5px;
                            color: white;
                            z-index: 100;
                        }
                    }
                    .r1 {
                        width: 260px;
                        display: flex;
                        flex-wrap: wrap;
                        margin-left: 10px;
                        .name {
                            width: 260px;
                            color: #1D1D1D;
                            margin: 10px 0;
                            font-weight: bold;
                        }
                        .tag-list {
                            display: flex;
                            flex-wrap: wrap;
                            align-content: flex-start;
                            .tag-item {
                                width: 50%;
                                .key {
                                    color: #666;
                                }
                                .value {
                                    color: #1A1A1A;
                                }
                                select {
                                    border: none;
                                    outline: none;
                                }
                            }
                        }
                    }

                    .form-group {
                        // width: 400px;
                        width:100%;
                        height: 40px;
                        padding: 0 10px;
                        background: #F5F5F5;
                        border-radius: 5px;
                        display: flex;
                        align-items: center;
                        .desc {
                            background: #F5F5F5;
                            margin-left: 10px;
                            width: 300px;
                            height: 40px;
                            line-height: 40px;
                            border: none;
                            outline: none;
                        }
                    }

                    .icon-del {
                        position: absolute;
                        top: 6px;
                        right: 6px;
                        width: 18px;
                        height: 18px;
                    }
                }
            }

            .mlist2 {
                display: flex;
                flex-wrap: wrap;
                .item {
                    position: relative;
                    width: 420px;
                    margin-bottom: 10px;
                    padding: 10px;
                    border: 1px solid #BFBFBF;
                    border-radius: 5px;
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    .img-wrap {
                        position: relative;
                        width: 100px;
                        height: 100px;
                        background: #F5F5F5;
                        .img-box{
                            position:relative;
                            width:100px;
                            height:100px;
                            .img {
                                width: 100%;
                                height: 100%;
                                object-fit: contain;
                            }
                            .replace-btn{
                                width:100px;
                                position:absolute;
                                bottom:11px;
                                left:50%;
                                transform:translateX(-50%);
                                background:rgba(0,0,0,0.4);
                                color:#ffffff;
                                font-size:13px;
                                display:flex;
                                align-items:center;
                                justify-content:center;
                                cursor:pointer;
                                .ico{
                                    width:18px;
                                    height:18px;
                                    // color:#ffffff;
                                }
                                .text{}
                            }
                        }
                        select {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 70px;
                            height: 25px;
                            background: rgba(0, 0, 0, 0.5);
                            border-radius: 5px;
                            color: white;
                            z-index: 100;
                        }
                        .img-default {
                            width: 120px;
                            height: 120px;
                            display: flex;
                            justify-content: center;
                            align-content: center;
                            flex-wrap: wrap;
                            .img2 {
                                width: 22px;
                                height: 22px;
                            }
                            p {
                                width: 100%;
                                text-align: center;
                            }
                        }
                    }
                    .r1 {
                        width: 260px;
                        display: flex;
                        flex-wrap: wrap;
                        margin-left: 10px;
                        .tag-list {
                            display: flex;
                            flex-wrap: wrap;
                            align-content: flex-start;
                            .tag-item {
                                width: 100%;
                                border-bottom: 1px solid #E6E6E6;
                                display: flex;
                                flex-wrap: nowrap;
                                align-items: center;
                                .key {
                                    width: 50px;
                                    color: #666;
                                }
                                .value {
                                    height: 30px;
                                    color: #1A1A1A;
                                    border: none;
                                    outline: none;
                                }
                                select {
                                    border: none;
                                    outline: none;
                                }
                            }
                        }
                    }

                    .form-group {
                        width: 400px;
                        height: 40px;
                        padding: 0 10px;
                        background: #F5F5F5;
                        border-radius: 5px;
                        display: flex;
                        align-items: center;
                        .desc {
                            background: #F5F5F5;
                            margin-left: 10px;
                            width: 300px;
                            height: 40px;
                            line-height: 40px;
                            border: none;
                            outline: none;
                        }
                    }

                    .icon-del {
                        position: absolute;
                        top: 6px;
                        right: 6px;
                        width: 18px;
                        height: 18px;
                    }
                }
                .btn-continue {
                    width: 420px;
                    height: 55px;
                    line-height: 55px;
                    color: #666666;
                    font-size: 14px;
                    text-align: center;
                    margin: 10px 0;
                    border-radius: 10px;
                    border: 1px solid #ccc;
                }
            }
        }

        .right {
            // margin: 0 auto;
            flex:1 1 auto;
            .material-wrap {
                margin-top: 10px;
                margin-right: 50px;
                padding: 10px;
                background: white;
                .top {
                    display: flex;
                    justify-content: space-between;
                    padding-bottom: 5px;
                    border-bottom: 2px solid #f6f7fa;
                    .title-box{
                        display:flex;
                        justify-content:center;
                        align-items:center;
                        column-gap:10px;
                        span{
                            font-size:16px;
                            color:#1a1a1a;
                            white-space:nowrap;
                            cursor:pointer;
                            box-sizing:border-box;
                            width:auto;
                            &.active{
                                font-size:18px;
                                font-weight:bold;
                            }
                            &:first-child{
                                // padding-right:10px;
                                // border-right:1px solid #333333;
                                box-sizing:border-box;
                            }
                            &:nth-child(2){
                                font-size:18px;
                            }
                        }
                    }
                    h2 {
                        font-size: 20px;
                        color: #1a1a1a;
                        white-space: nowrap;
                    }

                    .input-wrap {
                        margin-left: 50px;
                        width: 280px;
                        height: 35px;
                        position: relative;

                        &:focus {
                            border: none !important;
                        }

                        &::after {
                            border: none !important;
                        }

                        input {
                            width: 100%;
                            height: 100%;
                            background: #f2f2f2;
                            border-radius: 17px;
                            padding: 0 45px 0 20px;
                            border: none !important;

                            &:focus {
                                border: none !important;
                            }

                            &::after {
                                border: none !important;
                            }
                        }

                        .icon-search {
                            position: absolute;
                            right: 18px;
                            top: 50%;
                            transform: translateY(-50%);
                            width: 20px;
                            height: 20px;
                            cursor: pointer;
                        }
                    }
                }

                /* 主内容区 */
                .content {
                    display: flex;
                    .left-content{
                        flex-shrink: 0;
                        width: auto;
                        max-width: 450px;
                        /* margin-right: 30px; */
                        height: 100% !important;
                    }
                    /* 左侧分类 */
                    .category-list {
                        width: 100px;
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: center;
                        align-content: flex-start;
                        border-right: 1px solid #f6f7fa;
                        overflow-y: auto;
                        padding: 15px 0;

                        .category-item {
                            width: 80px;
                            height: 35px;
                            line-height: 35px;
                            text-align: center;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            color: #1C1C1C;
                            border-radius: 5px;
                            &.active {
                                background: #1C1C1C;
                                color: white;
                                font-weight: 500;
                            }
                        }
                    }

                    /* 右侧内容 */
                    .right-content {
                        $left_width: 140px;
                        width: calc(100% - #{$left_width});
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        padding: 10px;
                        overflow: hidden;

                        /* 标签筛选区 */
                        .label-list {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 12px 0;
                            margin-bottom: 5px;

                            .label-item {
                                padding: 0 15px;
                                height: 20px;
                                line-height: 20px;
                                border-radius: 15px;
                                //   background: #f6f6f6;
                                cursor: pointer;
                                transition: all 0.2s;

                                &.active {
                                    background: #ffecee;
                                    color: #fa3d5a;
                                    font-weight: 500;
                                }
                            }
                        }

                        /* 子分类 */
                        .sub-list {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 10px;
                            margin-top: 10px;
                            margin-bottom: 10px;
                            background: #f6f6f6;

                            .sub-item {
                                padding: 0 12px;
                                height: 28px;
                                line-height: 28px;
                                border-radius: 14px;
                                cursor: pointer;
                                transition: all 0.2s;

                                &.active {
                                    background: #fa3d5a;
                                    color: white;
                                }
                            }
                        }

                        .no-data {
                            width:300px;
                            height: auto;
                            display: block;
                            margin:0 auto;
                        }
                        /* 面料列表 */
                        .fabric-list {
                            flex: 1;
                            display: grid;
                            grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
                            border-radius: 5px;
                            // gap: 3px 0px;
                            // gap: 6px 0;
                            column-gap:30px;
                            row-gap:6px;
                            align-items: start;
                            overflow-y: auto;
                            padding: 15px;
                            background: #F6F7FA;
                            max-height:530px;

                            &::-webkit-scrollbar {
                                display: none !important;
                            }

                            .fabric-item {
                                position: relative;
                                width: 142px;
                                height: 175px;
                                margin: 0 5px 15px 5px;
                                cursor: pointer;
                                box-sizing: border-box;
                                border: 1px solid #e3e4e6;
                                border-radius: 5px;

                                img {
                                    width: 140px;
                                    height: 141px;
                                    border-top-left-radius: 5px;
                                    border-top-right-radius: 5px;
                                    object-fit: contain;
                                }

                                p {
                                    // width: 140px;
                                    width: 100%;
                                    height: 30px;
                                    line-height: 30px;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                    overflow: hidden;
                                    background: white;
                                    padding: 0 5px;
                                    border-top: 0.5px solid #e3e4e6;
                                    margin-top: -5px;
                                    text-align: center;
                                    border-bottom-left-radius: 5px;
                                    border-bottom-right-radius: 5px;
                                }

                                .icon-check {
                                    position: absolute;
                                    top: 0;
                                    right: 0;
                                    width: 25px;
                                    height: 25px;
                                }

                                &.active {
                                    border: 1px solid #fa3d5a;
                                }

                                .mask {
                                    display: none;
                                }

                                &:hover {
                                    .mask {
                                        display: block;
                                        position: absolute;
                                        top: 0;
                                        left: 0;
                                        right: 0;
                                        height: 140px;
                                        z-index: 100;
                                        background: rgba(0, 0, 0, 0.35);
                                        .btn{
                                            display:flex;
                                            align-items:center;
                                            justify-content: end;
                                            position: absolute;
                                            // top:115px;
                                            // right:10px;
                                            // column-gap:10px;
                                            width:100%;
                                            justify-content:space-between;
                                            bottom:0;
                                            padding:0 10px;
                                            .fa-detail {
                                                // right: 45px;
                                                // top: 115px;
                                                z-index: 101;
                                                color: white;
                                                font-weight: bold;
                                            }

                                            .fa-choose {
                                                // position: absolute;
                                                // right: 10px;
                                                // top: 115px;
                                                z-index: 101;
                                                color: white;
                                                font-weight: bold;
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        /* 底部按钮 */
                        .btn-group {
                            display: flex;
                            justify-content: flex-end;
                            gap: 15px;
                            padding-top: 10px;

                            .btn {
                                min-width: 100px;
                                height: 38px;
                                line-height: 38px;
                                border-radius: 5px;
                                cursor: pointer;
                                transition: all 0.2s;
                                text-align: center;

                                &.btn-cancel {
                                    color: black;
                                    border: 1px solid #e5e5e5;
                                }

                                &.btn-confirm {
                                    color: white;
                                    background: #fa3d5a;
                                }
                            }
                        }
                    }
                }

                .color-mask {
                    position: absolute;
                    top: 0;
                    right: 0;
                    left: 0;
                    bottom: 0;
                    background: rgba(0, 0, 0, 0.35);
                    z-index: 9999;
                    .color-wrap {
                        position: absolute;
                        width: 600px;
                        height: 300px;
                        top:calc(50% - 150px);
                        left: calc(50% - 300px);
                        background: white;
                        border-radius: 10px;
                        z-index: 10000;
                        padding: 20px 10px 0 10px;

                        .title {
                            font-size: 16px;
                            font-weight: bold;
                            color: #1a1a1a;
                        }

                        .color-list {
                            display: flex;
                            flex-wrap: wrap;
                            width: 560px;
                            height:100%;
                            min-height: 150px;
                            max-height:170px;
                            overflow-y:auto;
                            row-gap:10px;

                            .color-item {
                                width: 120px;
                                height: 46px;
                                border: 1px solid #e5e5e5;
                                border-radius: 5px 5px 5px 5px;
                                margin: 0 8px;
                                display: flex;
                                align-items: center;
                                padding: 0 5px;
                                cursor: pointer;

                                img {
                                    width: 30px;
                                    height: 30px;
                                    margin-right: 5px;
                                }

                                &.active {
                                    border-color: #fa3d5a;

                                    span {
                                        color: #fa3d5a;
                                    }
                                }
                            }
                        }

                        .btn-group {
                            margin-top: 24px;
                            display: flex;
                            justify-content: flex-end;
                            align-items: center;
                            border-top: 1px solid #e5e5e5;
                            height: 58px;

                            .btn {
                                width: 100px;
                                height: 38px;
                                line-height: 38px;
                                border-radius: 5px;
                                text-align: center;
                                font-size: 14px;
                                margin: 0 7px;
                                cursor: pointer;

                                &.btn-cancel {
                                    color: black;
                                    border: 1px solid #e5e5e5;
                                }

                                &.btn-confirm {
                                    color: white;
                                    background: #fa3d5a;
                                }
                            }
                        }
                    }
                }
            }
        }

    }

    @media (min-width:1280px) and (max-width:1679px){
        .inner-wrap{
            min-width:1200px;
            height:100%;
            overflow:visible;
            .left{
                flex-shrink:0;
                width:auto;
                max-width:450px;
                margin-right:30px;
                height:100% !important;
                .mlist,.mlist2{
                    width:100%;
                    .item{
                        width:100%;
                        .img-wrap{
                            width:100px !important;
                            height:100px !important;
                            .img{
                                width:100% !important;
                                height:100% !important;
                            }
                            ::v-deep .ivu-upload-select{
                                width:100%;
                                height:100%;
                            }
                            .img-default{
                                width:100%;
                                height:100px;
                            }
                        }
                        .r1{
                            width:150px;
                            .name{
                                margin:0;
                            }
                            .tag-list{
                                width:100%;
                                .tag-item{
                                    width:100%;
                                }
                            }
                        }
                        .form-group{
                            width:100%;
                            .desc{
                                width:auto;
                                flex:1;
                            }
                        }
                    }
                }
                .mlist2{
                    .item{
                        .img-wrap{
                            width:100px !important;
                            height:100px !important;
                            ::v-deep .ivu-upload{
                                width:100%;
                                height:100%;
                            }
                            ::v-deep .ivu-upload-select{
                                width:100%;
                                height:100%;
                            }
                            .img-box{
                                width:100% !important;
                                height:100% !important;
                                .img{
                                    width:100% !important;
                                    height:100% !important;
                                    object-fit:cover;
                                }
                            }
                        }
                        .r1{
                            width:auto;
                            flex:1;
                            overflow:hidden;
                            .tag-list{
                                .tag-item{
                                    span{
                                        flex:1;
                                        flex-shrink:0;
                                    }
                                    input{
                                        width:210px;
                                    }
                                }
                            }
                        }

                    }

                }
            }
            .right{
                flex:1 1 auto;
                max-width:1100px;
                max-height:730px;
                flex-shrink:0;
                margin-right:0;
                margin-left:0;
                height:100%;
                .material-wrap{
                    height:100% !important;
                    margin-right:0;
                    .content{
                        .category-list{
                            min-width:100px;
                        }
                        .right-content{
                            max-height:700px;
                            .fabric-list{
                                gap:6px 10px;
                            }
                        }
                    }
                }
            }
        }
    }

    @media (max-width:1279px){
        .inner-wrap{
            min-width:1200px;
            height:100%;
            overflow:visible;
            .left{
                flex-shrink:0;
                width:auto;
                max-width:350px;
                margin-right:10px;
                height:100% !important;
                .mlist,.mlist2{
                    width:100%;
                    .item{
                        width:100%;
                        .img-wrap{
                            width:100px;
                            height:100px;
                            .img{
                                width:100%;
                                height:100%;
                            }
                            ::v-deep .ivu-upload-select{
                                width:100%;
                                height:100%;
                            }
                            .img-default{
                                width:100%;
                                height:100px;
                            }
                        }
                        .r1{
                            width:150px;
                            .name{
                                margin:0;
                            }
                            .tag-list{
                                width:100%;
                                .tag-item{
                                    width:100%;
                                }
                            }
                        }
                        .form-group{
                            width:100%;
                            .desc{
                                width:auto;
                                flex:1;
                            }
                        }
                    }
                }
                .mlist2{
                    .item{
                        .img-wrap{
                            width:100px !important;
                            height:100px !important;
                            ::v-deep .ivu-upload{
                                width:100%;
                                height:100%;
                            }
                            ::v-deep .ivu-upload-select{
                                width:100%;
                                height:100%;
                            }
                            .img-box{
                                width:100% !important;
                                height:100% !important;
                                .img{
                                    width:100% !important;
                                    height:100% !important;
                                    object-fit:cover;
                                }
                            }
                        }
                        .r1{
                            width:auto;
                            flex:1;
                            overflow:hidden;
                            .tag-list{
                                .tag-item{
                                    span{
                                        flex:1;
                                        flex-shrink:0;
                                    }
                                    input{
                                        width:110px;
                                    }
                                }
                            }
                        }

                    }

                }
            }
            .right{
                flex:1 1 auto;
                max-width:1100px;
                max-height:730px;
                flex-shrink:0;
                margin-right:0;
                margin-left:0;
                height:100%;
                .material-wrap{
                    height:100% !important;
                    margin-right:0;
                    .content{
                        .category-list{
                            min-width:100px;
                        }
                        .right-content{
                            max-height:700px;
                            .fabric-list{
                                gap:6px 10px;
                            }
                        }
                    }
                }
            }
        }
    }


    ::v-deep .popup-modal {
        /* 核心容器 */
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 999;
        background: rgba(0, 0, 0, 0.6);

        /* 弹窗内容区 */
        .popup-content {
            background: #fff;
            border-radius: 10px;
            //   width: min(980px, 92vw); // 最大980px，最小占92%视口宽
            /* 修正后 */
            width: max(980px, 96vw); // 增加视口占比
            min-width: 320px; // 保障最小可操作宽度
            max-width: none !important; // 移除潜在限制

            /* 添加边距保护 */
            margin: 0 2vw; // 左右留白
            box-sizing: content-box; // 防止padding影响
            max-height: max(720px, 85vh); // 最大720px，最小占85%视口高
            height: 30vh;
            display: flex;
            flex-direction: column;
            overflow: hidden;
        }
    }

    .fabric-content-wrap {
        margin-top: 40px;
        overflow-y: scroll;
        height: 600px;
        position:relative;
        display:flex;
        flex-direction:column;
        .title-box{
            display:flex;
            align-items: center;
            column-gap:13px;
            .title {
                color: #1a1a1a;
                font-size: 16px;
                border-left: none;
                font-weight: bold;
                margin-bottom: 0;
                padding: 10px 0;
                height: auto;
            }
            .line{
                flex:1;
                height:1px;
                background:#ebebeb;
            }
        }

        .info-wrap {
            display: flex;
            justify-content: space-around;
            min-height:430px;
            .left-popup {
                width: 420px;
                border:1px solid #e5e5e5;
                .f-img {
                    width: 420px;
                    height: 420px;
                }
            }

            .right {
                // width: 500px;
                flex:1;
                padding-right:20px;
                padding-left:20px;
                .name {
                    color: #1a1a1a;
                    font-size: 20px;
                }

                .no {
                    color: #808080;
                    font-size: 14px;
                    margin-bottom:20px;
                    // margin: 25px 0;
                }
                .price{
                    color:#e00000;
                    font-size:18px;
                    font-weight:bold;
                    padding-bottom:17px;
                }
                .item {
                    margin: 5px 0;

                    .key {
                        display: inline-block;
                        color: #808080;
                        // width: 80px;
                    }

                    .value {
                        color: #1a1a1a;
                    }
                }
                .color-title{
                    color:#1a1a1a;
                    font-size:16px;
                    font-weight:bold;
                }
                .color-box{
                    width:100%;
                    display:flex;
                    flex-wrap:wrap;
                    column-gap:10px;
                    row-gap:10px;
                    margin-top:26px;
                    .color-item{
                        width:112px;
                        height:40px;
                        display: flex;
                        align-items:center;
                        justify-content:center;
                        column-gap:6px;
                        border-radius:5px;
                        border:1px solid #e5e5e5;
                        color:#4d4d4d;
                        cursor:pointer;
                        .color-img{
                            width:25px;
                            height:25px;
                            border-radius:5px;
                        }
                        &.active{
                            border:1px solid #fa3d5a;
                            color:#fa3d5a;
                        }
                    }
                }
            }
        }

        .richtext-wrap {
            flex:1;
            padding-bottom:60px;
        }
        .btn-box{
            display:flex;
            justify-content:center;
            column-gap:20px;
            position:sticky;
            bottom:0;
            left:0;
            right:0;
            z-index:1;
            background:#ffffff;
            padding:10px 0;
            .cancel-btn{
                width:120px;
                height:38px;
                border-radius:19px;
                background:#ffffff;
                border:1px solid #e5e5e5;
                color:#1a1a1a;
                font-size:14px;
                cursor:pointer;
            }
            .confirm-btn{
                width:120px;
                height:38px;
                border-radius:19px;
                background:#1a1a1a;
                color:#ffffff;
                font-size:14px;
                cursor:pointer;
            }
        }
    }

    .slider {
        width: 420px;
        height: 420px;
        overflow: hidden;

        .swiper-slide {
            width: 420px;
            height: 420px;
        }

        .img, video {
            width: 420px;
            height: 420px;
            object-fit:contain;
        }
    }

    ::v-deep .viewer-container {
        z-index: 999999 !important;
        }
</style>
